import React, { useState, useEffect } from "react";
import Accordion from "../../hooks/Accordion";

// css
import "./offering-details.css";

const AdvisorFees = () => {
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);
  return (
    <section id="advisor-fees" className="advisor-fees-section">
      {screenSize.dynamicWidth < 900 ? (
        <div>
          <h1 className="sub-header sub-header-mobile">Advisor Fees</h1>
          <div style={{ borderTop: "1px solid black" }}>
            <Accordion title="Management Fee">
              <span>
                1.25% per annum of NAV<sup>7</sup>, payable monthly
              </span>
            </Accordion>
            <Accordion
              title="Performance Participation Allocation"
              content="12.5% of the total return, subject to a 5% hurdle amount and a
                  high-water mark with a catch-up"
            />
          </div>
        </div>
      ) : (
        <div style={{ padding: "30px 80px 80px 80px" }}>
          <div className="main-margin">
            <h1 className="sub-header mb-10">Advisor Fees</h1>
            {/* odtable-header is initially used in the ODTable component. Brought here for consistency */}
            <table className="odtable-header table-shadow-main">
              <tr>
                <th className="odtable-tableheader">Fee</th>
                <th className="odtable-tableheader">Description</th>
              </tr>
              <tr>
                <td className="odheader-slim fw-6">Management Fee</td>
                <td>
                  1.25% per annum of NAV<sup>7</sup>, payable monthly
                </td>
              </tr>
              <tr>
                <td className="fw-6">Performance Participation Allocation</td>
                <td>
                  12.5% of the total return, subject to a 5% hurdle amount and a
                  high-water mark with a catch-up
                </td>
              </tr>
            </table>
          </div>
        </div>
      )}
    </section>
  );
};

export default AdvisorFees;
